import TortasMaster from './Master';
export default class FacturaPie extends TortasMaster {
    state = { title: '', values: [] };
    estados = ['CANCELADO', '', 'FACTURADA'];
    api = 'Factura';
    title='FACTURAS'
}